/**
 * Sigilo de Minerva — búho geométrico de una sola tinta.
 * Usa `currentColor` para el trazo (hereda el color del contexto: oro por
 * defecto) y permite un acento para las pupilas. Reutilizado en Header, chat,
 * empty states y marcas marginales.
 */
export default function MinervaMark({
  size = 32,
  strokeWidth = 1.3,
  pupil = 'var(--gilt-bright, #DCC079)',
}: {
  size?: number;
  strokeWidth?: number;
  pupil?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'var(--gilt, #C2A24E)' }}
      aria-hidden="true"
    >
      {/* orejas / penachos */}
      <path d="M16 13 L18.6 7.5 L21.2 13" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
      <path d="M26.8 13 L29.4 7.5 L32 13" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
      {/* cabeza */}
      <circle cx="24" cy="23" r="11.3" stroke="currentColor" strokeWidth={strokeWidth} />
      {/* disco facial: dos arcos */}
      <path d="M24 13.5 Q17.5 18 19.2 27" stroke="currentColor" strokeWidth={strokeWidth} opacity="0.5" strokeLinecap="round" />
      <path d="M24 13.5 Q30.5 18 28.8 27" stroke="currentColor" strokeWidth={strokeWidth} opacity="0.5" strokeLinecap="round" />
      {/* ojos */}
      <circle cx="19.6" cy="22" r="3.5" stroke="currentColor" strokeWidth={strokeWidth} />
      <circle cx="28.4" cy="22" r="3.5" stroke="currentColor" strokeWidth={strokeWidth} />
      <circle cx="19.6" cy="22" r="1.45" fill={pupil} />
      <circle cx="28.4" cy="22" r="1.45" fill={pupil} />
      {/* pico */}
      <path d="M24 25.5 L22.2 29 L25.8 29 Z" fill="currentColor" />
    </svg>
  );
}
